import { Header } from '@ytl/common-web';
import { ReactElement, ReactNode, useCallback } from 'react';
import { useApp } from '../../../../contexts/appContext';
import { useLanguage } from '../../../../contexts/languageContext';

export interface FrameProps {
  children: ReactNode;
  isAuthenticated: boolean;
  disableHeader?: boolean;
}

export const Frame = (props: FrameProps): ReactElement => {
  const { language, setLanguage } = useLanguage();
  const { menuItems } = useApp();
  const onLanguageChange = useCallback(() => {
    if (language === 'hu') {
      setLanguage('en');
    } else {
      setLanguage('hu');
    }
  }, [language, setLanguage]);

  return (
    <>
      <div className={`frame${props.isAuthenticated ? ' frame--authenticated' : ' frame--unauthenticated'}`}>
        {!props.disableHeader && (
          <div className="frame__header">
            <Header
              mode={'b2c'}
              menuItems={menuItems}
              language={language}
              onLanguageClick={onLanguageChange}
            ></Header>
          </div>
        )}
        <main className="frame__content">{props.children}</main>
      </div>
    </>
  );
};
